<template>
  <el-row>
    <el-col class="media-info-content">
      <div class="media-info-content__column media-info-column">
        <div class="media-info-column__item media-info">
          <span class="media-info-label">Stream:</span>
          <span class="media-info-value">{{ stream }}</span>
        </div>
      </div>

      <div class="media-info-content__column media-info-column">
        <div class="media-info-column__item media-info">
          <span class="media-info-label">Start Time:</span>
          <span class="media-info-value">{{ startTimeline }}</span>
        </div>
        <div class="media-info-column__item media-info">
          <span class="media-info-label">End Time:</span>
          <span class="media-info-value">{{ endTimeline }}</span>
        </div>
        <div v-if="duration" class="media-info-column__item media-info">
          <span class="media-info-label">Duration:</span>
          <span class="media-info-value">{{ durationLine }}</span>
        </div>
        <div class="video-mangomolo-controls">
          <el-dropdown trigger="click">
            <el-button class="share-dropdown-btn" type="primary">
              {{ titleBtn }}
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="uploadToMangomolo">
                <div
                  class="mangomolo-upload-button"
                  @click="$emit('uploadToMangomolo')"
                >
                  Upload to mangomolo
                </div>
              </el-dropdown-item>

              <el-dropdown-item v-if="snapchatLink">
                <a :href="snapchatLink" target="_blank">
                  <div class="snapchat-share-button">
                    Snapchat
                  </div>
                </a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import youtubeIcon from "@/assets/images/youtube_sharing.png";
import facebookIcon from "@/assets/images/facebook_sharing.png";
import instagramIcon from "@/assets/images/instagram_sharing.png";
import twitterIcon from "@/assets/images/twitter_sharing.png";

import { getDateAndTimeLine, getDurationTimeline } from "@/utils/time.js";

// @group Media/Audio
// Audio item information
export default {
  name: "AudioItemContent",
  props: {
    /** Wowza live-application name */
    app: {
      type: String,
      default: "No App"
    },
    /** link to share to Snapchat */
    snapchatLink: {
      type: String,
      default: null
    },
    /** Wowza stream name */
    stream: {
      type: String,
      default: "No Stream"
    },
    /** Audio duration in seconds */
    duration: {
      type: Number,
      default: null
    },
    /** Audio start time in origin stream */
    startTime: {
      type: Date,
      default: null
    },
    /** is clip uploaded to MM */
    uploadToMangomolo: {
      type: Boolean,
      default: true
    },
    /** Audio end time in origin stream */
    endTime: {
      type: Date,
      default: null
    }
  },
  data() {
    return {
      /** icons */
      youtubeIcon,
      facebookIcon,
      instagramIcon,
      twitterIcon,
      titleBtn: 'Share audio'
    };
  },
  computed: {
    ...mapGetters(["channelType"]),
    ...mapState({
      timezone: state => state.timezone.timezone
    }),
    // @vuese
    // Duration as (start - end). It may to be different from 'duration'
    // property because duration can be changed adter convertion, so this
    // computed has less priority than 'duration' property
    calculatedDuration() {
      return (this.endTime - this.startTime) / 1000;
    },
    // @vuese
    // Actual duration after convertion or calculated by start-end when
    // audio is converting
    actualDuration() {
      return this.duration ?? this.calculatedDuration;
    },
    // @vuese
    // Duration time in format HH:mm:ss
    durationLine() {
      return getDurationTimeline(this.actualDuration);
    },
    // @vuese
    // Audio start time in format DD-MM-YYYY HH:mm:ss
    startTimeline() {
      return getDateAndTimeLine(this.startTime / 1000, this.timezone);
    },
    // @vuese
    // Audio end time in format DD-MM-YYYY HH:mm:ss
    endTimeline() {
      return getDateAndTimeLine(this.endTime / 1000, this.timezone);
    }
  }
};
</script>

<style lang="scss" scoped>
/** info */
.media-info-content {
  display: flex;
  justify-content: space-between;

  &__column {
    padding: 0.5em;
  }
}
.media-info-column {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  &__item {
    height: 2em;
  }
}
.media-info {
  justify-self: start;
  text-align: start;
  font-size: 14px;
}
.media-info-label {
  margin-right: 5px;
  display: inline-block;
  color: #ffffff;
}
.media-info-value {
  margin-right: 5px;
  display: inline-block;
  color: white;
}

.share-dropdown-btn {
  height: 30px;
  padding-top: 5px;
  padding-bottom: 5px;

  border: none;

  color: white;
  background-color: var(--grey);
}

.mangomolo-upload-button {
  padding-right: 28px;
  background-image: url("../../../assets/logo-small.png");
  background-position: center right 0px;
  background-size: 20px;
  background-repeat: no-repeat;
}

/** sharing */
.video-mangomolo-controls {
  display: flex;
  flex-wrap: wrap;
  margin: 5px 0 5px 0;
}
.video-mangomolo-controls .el-button {
  margin: 5px 5px 5px 0;
}

@media only screen and (max-width: 767px) {
  /** media info */
  .media-info {
    margin-left: 15px;
    font-size: 13px;
  }
  .video-mangomolo-controls {
    justify-content: center;
  }
}

@media only screen and (min-width: 768px) {
  /** media info */
  .media-info {
    font-size: 16px;
  }
}

@media only screen and (min-width: 992px) {
  /** media info */
  .media-info {
    font-size: 11px;
  }
}

@media only screen and (min-width: 1200px) {
  /** media info */
  .media-info {
    font-size: 13px;
  }
}

@media only screen and (min-width: 1920px) {
  /** media info */
  .media-info {
    font-size: 15px;
  }
}
</style>
